import Swiper, { Pagination, Navigation, Autoplay } from 'swiper';

const productsSwipers = new Swiper('.package-comparison-swiper', {
    modules: [Navigation],
    spaceBetween: 12,
    slidesPerView: "auto",
    initialSlide: 2,
    centeredSlides: !pakietymedyczneJSON.isMobile,
    centeredSlidesBounds: !pakietymedyczneJSON.isMobile,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    }
});


if (document.querySelector('.wp-testimonials')) {
    const testimonialSwiper = new Swiper(".wp-testimonials", {
        modules: [Navigation],
        spaceBetween: 32,
        slidesPerView: "auto",
        centeredSlides: true,
        loop: true,
        initialSlide: 1,
        navigation: {
            nextEl: ".wp-testimonials-next",
            prevEl: ".wp-testimonials-prev",
        }
    });
}


if (document.querySelector('.lp-sport-mockup-swiper')) {
    const testimonialSwiper = new Swiper(".lp-sport-mockup-swiper", {
        modules: [Autoplay],
        slidesPerView: 2,
        spaceBetween: 32,
        freeMode: true,
        loop: true,
        autoplay: {
            delay: 1,
            disableOnInteraction: false
        },
        speed: 9000,
        freeModeMomentum: false,
    });
}


if (document.querySelector('.lp-sport-hero-swiper')) {
    const testimonialSwiper = new Swiper(".lp-sport-hero-swiper", {
        modules: [Autoplay],
        freeMode: true,
        spaceBetween: 0,
        slidesPerView: 3.5,
        loop: true,
        autoplay: {
            delay: 1,
            disableOnInteraction: false
        },
        speed: 5000,
        freeModeMomentum: false,
        direction: "vertical",
    });
}